// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cbp-footer{height:104px;background-color:#f0f0f0}.cbp-footer *{margin:unset;font-size:16px;line-height:normal}.cbp-footer__container{height:100%;display:flex;justify-content:space-between;align-items:center}.cbp-footer__container:before,.cbp-footer__container:after{content:none !important}@media(max-width: 667px){.cbp-footer__container{flex-direction:column;justify-content:center;align-items:center}}", ""]);
// Exports
module.exports = exports;
